import React from 'react'
import Box from '@material-ui/core/Box'
import IconMap from './IconMap'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => {
  const { main } = theme.palette.primary
  return {
    speciesCardStyleOnSelected: {
      '& .MuiTypography-body2, svg': {
        color: main,
        fontWeight: theme.typography.fontWeightBold,
      },
    },
    iconBoxStyle: {
      width: theme.spacing(15),
      height: theme.spacing(10),
      padding: '5px 9px',
      '& svg': {
        width: '100%',
        height: '100%',
      },
    },
    labelStyle: {
      paddingLeft: '8px',
      textWrap: 'nowrap',
      marginLeft: theme.spacing(2),
    },
  }
})

interface SpeciesCardProps {
  name: string | null | undefined
  checked: boolean
}

const SpeciesCard: React.FC<SpeciesCardProps> = ({ name, checked }) => {
  const classes = useStyles()
  const speciesBoxStyle = clsx(checked && classes.speciesCardStyleOnSelected)

  return (
    <Box display="flex" flexDirection="row" className={speciesBoxStyle}>
      <Box className={classes.iconBoxStyle}>
        <IconMap iconName={name} />
      </Box>
      <Box display="flex" alignItems="center" className={speciesBoxStyle}>
        <Typography
          variant="body2"
          display="inline"
          className={classes.labelStyle}
        >
          {name}
        </Typography>
      </Box>
    </Box>
  )
}
export default SpeciesCard
